import { MenuItem } from '@mui/material';
import React from 'react';
export default function OrgSwitcherMenuItem({ _id, name, switchAction, closeMenu, }) {
    return (React.createElement(MenuItem, { "data-cy": `org-id-${_id}-cool`, key: _id, title: 'Click to switch orgs', onClick: () => {
            switchAction(_id);
            closeMenu();
        } }, name ? name : _id));
}
